// frontend/modules/notification-config/index.ts
import { ModuleConfig } from '@/core/module';
import { notificationConfigRoutes } from './routes';
import { useNotificationConfigStore } from './stores/notification-config-store';

/**
 * Notification Configuration module definition
 */
export const NotificationConfigModule: ModuleConfig = {
  name: 'notification-config',
  routes: notificationConfigRoutes,
  stores: {
    notificationConfig: useNotificationConfigStore
  },
  
  // Initialization logic
  initialize: () => {
    console.log('Notification Configuration module initialized');
  },
  
  // Cleanup logic
  cleanup: () => {
    console.log('Notification Configuration module cleanup');
  }
};
